var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnimalsDefol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.396346 10.7971L28.8554 10.0015C30.7281 9.94953 33.0387 11.2304 33.9906 12.8631L41.7998 26.2488C41.8933 26.41 41.9902 26.6024 42.0802 26.8104L42.0058 26.339H45L42.6271 28.6216L43.4389 34.0848C43.5427 34.785 43.0667 35.3327 42.3813 35.3327H42.4921C41.7998 35.3327 40.8825 34.9046 40.4308 34.376L37.6044 31.0724C37.151 30.5421 36.7858 29.5558 36.7858 28.8643V27.6718L32.3013 26.4672L36.6733 35.2235H34.2329L27.9658 25.8953H12.7177L10.8779 27.7758C10.3933 28.2698 9.46212 28.7187 8.75077 28.7811L5.59385 29.0601L6.44192 36H4.40654L2.33654 27.6614C2.17038 26.9941 2.44558 26.0842 2.96135 25.6249L4.32 24.4116L1.13192 13.3467V24.786H0V10.7988L0.396346 10.7971ZM11.3002 28.0081L13.6748 35.7244L11.5287 35.669L7.91135 29.3947L8.93596 29.3201C9.60058 29.2699 10.549 28.8192 11.0163 28.3149L11.3019 28.0063L11.3002 28.0081ZM27.5175 26.4516L29.1583 28.7846L28.6494 35.4471H26.7767L26.3319 26.4516H27.5175Z",
    fill: "#36975C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsDefol);
export default __webpack_public_path__ + "static/media/ic-animals-defol.8b8747c8ae342328230db771319ff0e8.svg";
export { ForwardRef as ReactComponent };